import { useLayoutEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ActionTypes } from "../store/types";
import { submitSquadSelection } from "../store/actions";

import Popup from "reactjs-popup";

import yourSquadHeadline from "../assets/headlines/your-squad.png";
import { Squad } from "../components/Squad";
import scss from "./Modal.module.scss";

export const Modal = () => {
  const dispatch = useDispatch();
  const { modal, selectedCharacters } = useSelector((state: any) => state);
  useLayoutEffect(() => {
    // Get original body overflow
    const originalStyle = window.getComputedStyle(document.body).overflow;
    // Prevent scrolling on mount
    document.body.style.overflow = "hidden";
    // Re-enable scrolling when component unmounts
    return () => {
      document.body.style.overflow = originalStyle;
    };
  }, []);

  const handleClick = (e) => {
    if (e.target.id === "modalOverlay") {
      dispatch({
        type: ActionTypes.CLOSE_MODAL,
      });
    }
  };

  const handleClose = () => {
    dispatch({
      type: ActionTypes.CLOSE_MODAL,
    });
  };

  const handleSubmit = () => {
    dispatch(submitSquadSelection());
  };

  let modalContent = (
    <>
      <h3>{modal.message}</h3>
      <button className={scss.button} onClick={handleClose}>
        CLOSE
      </button>
    </>
  );
  if (modal.template === "CONFIRM_SQUAD_SUBMIT") {
    modalContent = (
      <>
        <img
          className={scss.headline}
          src={yourSquadHeadline}
          alt="your squad"
        />
        <Squad squad={selectedCharacters} />
        <div className={scss.buttons}>
          <button className={scss.button} onClick={handleClose}>
            GO BACK
          </button>
          <button className={scss.button} onClick={handleSubmit}>
            SUBMIT
          </button>
        </div>
      </>
    );
  }

  return (
    <Popup open={modal.open}>
      <div id="modalOverlay" className={scss.overlay} onClick={handleClick}>
        <div className={scss.modal}>{modalContent}</div>
      </div>
    </Popup>
  );
};
